import getBaseUrl from './getBaseUrl.js';

export default async function getAppConfig() {
  const baseUrl = getBaseUrl();

  const response = await fetch(`${baseUrl}/app-config`, {
    headers: {
      Accept: 'application/json',
      'Accept-encoding': 'gzip',
      'Content-type': 'application/json; charset=UTF-8'
    },
    method: 'GET'
  });

  if (!response.ok) {
    const data = parseData(await response.text());

    throw Object.assign(new Error(response.statusText), {
      response: { status: response.status, data }
    });
  }

  const config = await response.json();
  return config;
}

function parseData(text) {
  let data;

  try {
    if (typeof text === 'string') {
      data = JSON.parse(text);
    }
    // eslint-disable-next-line no-empty
  } catch {}

  return data;
}
